var map = {
	"./01.jpg": "80ee",
	"./02.jpg": "e626",
	"./03.jpg": "2bf2",
	"./04.jpg": "aaee",
	"./05.jpg": "64f2",
	"./06.jpg": "d07d",
	"./07.jpg": "6d09",
	"./08.jpg": "cd4f",
	"./09.jpg": "2b80",
	"./10.jpg": "5352",
	"./11.jpg": "ed13",
	"./12.jpg": "931b",
	"./combination_bg.jpg": "714d",
	"./highlight_1.png": "3d23",
	"./highlight_2.png": "f7d4",
	"./highlight_3.png": "0846",
	"./icon-highlight.png": "415c",
	"./icon-photo.png": "b8d1",
	"./icon-video.png": "4fb4",
	"./photo_info_bg.png": "a538",
	"./photoarrow.png": "3a76",
	"./photoshadow.png": "4e9b",
	"./pro_img.png": "a057",
	"./section_bg.png": "f6e7",
	"./section_kanban.png": "0978",
	"./section_logo1.png": "a43d",
	"./section_logo2.png": "c17e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b1dc";